module.exports = __webpack_public_path__ + "static/media/sos-alarm.327c021a.mp3";